"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackExceptionGA4 = exports.trackException = exports.trackEventGA4 = exports.trackEvent = exports.setData = exports.getGoogleAnalytics = exports.getAllGoogleAnalytics = exports.disableForThisPage = exports.anonymizeIps = exports.trackShareEvent = void 0;
const browser_rum_1 = require("@datadog/browser-rum");
const errors_1 = require("../appMonitoring/errors");
const env_1 = require("../env");
// Didn't export this on purpose, so no one tries to use it to do something wacky.
const getAllGoogleAnalytics = () => {
  var _window, _window2, _window2$ga, _window2$ga$getAll;
  if ((0, env_1.isServer)() || !window || !((_window = window) !== null && _window !== void 0 && _window.ga)) return null;
  const trackers = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$ga = _window2.ga) === null || _window2$ga === void 0 ? void 0 : (_window2$ga$getAll = _window2$ga.getAll) === null || _window2$ga$getAll === void 0 ? void 0 : _window2$ga$getAll.call(_window2$ga);
  if (!trackers || !trackers.length) return null;
  return trackers;
};
exports.getAllGoogleAnalytics = getAllGoogleAnalytics;
// Didn't export this on purpose, so no one tries to use it to do something wacky.
const getGoogleAnalytics = () => {
  const trackers = getAllGoogleAnalytics();
  return trackers ? trackers[0] : null;
};
exports.getGoogleAnalytics = getGoogleAnalytics;
// Page View is not implemented here because our system automatically tracks Page Views.
// You really shouldn't be doing that manually.
const setData = (key, value) => {
  const ga = getGoogleAnalytics();
  if (!ga) return;
  ga.send('set', key, value);
  browser_rum_1.datadogRum.addRumGlobalContext(`data_${key}`, value);
};
exports.setData = setData;
const anonymizeIps = () => setData('anonymizeIp', true);
exports.anonymizeIps = anonymizeIps;
const trackEventGA4 = function ( /** The name in the event. This is what's visible at the top-level in GA4 report UIs */
eventName, eventCategory) {
  var _window3;
  let eventLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  let eventValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  let nonInteraction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  if (typeof window !== 'undefined' && typeof ((_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.dataLayer) !== 'undefined') {
    var _window$dataLayer;
    (_window$dataLayer = window.dataLayer) === null || _window$dataLayer === void 0 ? void 0 : _window$dataLayer.push({
      event: `generic_ga4_event`,
      eventCategory,
      eventAction: eventName,
      eventLabel,
      eventValue,
      nonInteraction
    });
  }
  if (browser_rum_1.datadogRum.getInternalContext()) {
    browser_rum_1.datadogRum.addAction(eventName, {
      eventCategory,
      eventLabel,
      eventValue,
      nonInteraction
    });
  }
};
exports.trackEventGA4 = trackEventGA4;
/**
 * @deprecated use trackEventGA4
 * eventAction becomes eventName in trackEventGA4
 * */
const trackEvent = function (eventCategory, eventAction) {
  let eventLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  let eventValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
  let nonInteraction = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  const ga = getGoogleAnalytics();
  if (!ga) return;
  ga.send('event', {
    eventCategory,
    eventAction,
    eventLabel,
    eventValue,
    transport: 'beacon',
    nonInteraction
  });
  trackEventGA4(eventAction, eventCategory, eventLabel, eventValue, nonInteraction);
};
exports.trackEvent = trackEvent;
// based on GA4 recommendations specific to sharing
// https://developers.google.com/analytics/devguides/collection/ga4/reference/events?client_type=gtag#share
const trackShareEvent = _ref => {
  let {
    contentType = 'page',
    itemId,
    method = 'Web Share'
  } = _ref;
  try {
    if (window && window.dataLayer) {
      var _window$dataLayer2;
      (_window$dataLayer2 = window.dataLayer) === null || _window$dataLayer2 === void 0 ? void 0 : _window$dataLayer2.push({
        event: 'share',
        method,
        content_type: contentType,
        item_id: itemId
      });
      if (browser_rum_1.datadogRum.getInternalContext()) {
        var _browser_rum_1$datado;
        (_browser_rum_1$datado = browser_rum_1.datadogRum) === null || _browser_rum_1$datado === void 0 ? void 0 : _browser_rum_1$datado.addAction('share', {
          method,
          content_type: contentType,
          item_id: itemId
        });
      }
    }
  } catch (error) {
    (0, errors_1.noticeError)(error, {
      method,
      content_type: contentType,
      item_id: itemId
    });
  }
};
exports.trackShareEvent = trackShareEvent;
const trackExceptionGA4 = function (exception) {
  let fatal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  trackEventGA4('error', exception === null || exception === void 0 ? void 0 : exception.name, exception === null || exception === void 0 ? void 0 : exception.message, fatal ? 'fatal' : null);
};
exports.trackExceptionGA4 = trackExceptionGA4;
/** @deprecated use trackExceptionGA4 */
const trackException = function (exception) {
  let fatal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const ga = getGoogleAnalytics();
  if (!ga) return;
  if (!exception || !exception.message) return;
  ga.send('exception', {
    exDescription: exception.message,
    exFatal: fatal
  });
  trackExceptionGA4(exception, fatal);
};
exports.trackException = trackException;
const disableForThisPage = function () {
  let accountId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  if (process.env.BUILD_TARGET === 'server') return true;
  if (accountId) {
    window[`ga-disable-${accountId}`] = true;
    return true;
  }
  const trackers = getAllGoogleAnalytics();
  if (trackers && trackers.length) {
    trackers.forEach(tracker => {
      window[`ga-disable-${tracker.get('trackingId')}`] = true;
    });
    return true;
  }
  return false;
};
exports.disableForThisPage = disableForThisPage;